var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgAddOrg = function SvgAddOrg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.412 21.564"
  }, props), _style || (_style = /*#__PURE__*/React.createElement("style", null, ".add-org_svg__st0{fill:none;stroke:#000;stroke-linecap:round;stroke-linejoin:round}")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__f76c7bd2-7ba4-4c80-a5d6-86cc1e8543e8",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__be557b76-3647-4b5d-8719-a6dc2ff05367",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.954 4.136v11.818",
    className: "add-org_svg__st0"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 13.636,
    height: 3.636,
    x: 4.136,
    y: 0.5,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.545,
    height: 4.545,
    x: 8.682,
    y: 15.954,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("rect", {
    width: 4.545,
    height: 4.545,
    x: 0.5,
    y: 15.954,
    className: "add-org_svg__st0",
    rx: 0.909
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.545 10.5H4.135a.91.91 0 0 0-.909.91v4.546",
    className: "add-org_svg__st0"
  })), /*#__PURE__*/React.createElement("g", {
    id: "add-org_svg__beb23c06-ac02-4262-8f76-9b3e8d31f877",
    className: "add-org_svg__st0",
    "data-name": "Isolation Mode"
  }, /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__bef30d3e-35aa-4c26-b7e6-6e837162a1b3",
    d: "M19.662 21.064a4.25 4.25 0 1 0-4.25-4.25 4.25 4.25 0 0 0 4.25 4.25",
    className: "add-org_svg__st0",
    "data-name": "Oval 119"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__fd96bf87-5d64-4bca-8f78-417b6864828e",
    d: "M19.662 14.689v4.25",
    className: "add-org_svg__st0",
    "data-name": "Shape 417"
  }), /*#__PURE__*/React.createElement("path", {
    id: "add-org_svg__bb042232-fc88-42cf-8215-d7e7b40807a9",
    d: "M21.787 16.814h-4.25",
    className: "add-org_svg__st0",
    "data-name": "Shape 418"
  })))));
};
export default SvgAddOrg;